module.exports = __webpack_public_path__ + "static/media/sidebar-6.c879fd13.jpg";